import * as yup from 'yup'

const schema = {
  title: yup.string().required(),
}

export const announcementValidationSchema = yup.object().shape(schema)
